<template>
  <div>


    <toggle-collapse>
      <DevicesListFilters :haseSupportFilter="true" :filterFor="report_type" :oldFilterData="request"
        @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />

    </toggle-collapse>



    <!-- <toggle-collapse>
        
      </toggle-collapse> -->
    <b-card style="position: relative">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">
        <b-row class="mt-4 ">

          <!-- devices  -->
          <b-col :cols="report_type == 'report' ? 6 : 12">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), id: 'all' }, ...devices]" :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <b-col v-if="report_type == 'report'" md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{ ('from' in errors) ? errors['from'][0] : '' }}
                {{ ('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>





        </b-row>


        <b-row>
          <b-col cols="12">

            <!-- 
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-toggle.collapse-1 variant="outline-primary"
              class=" mb-12">
              <feather-icon icon="FilterIcon" size="16" :class="'text-primary'" />
              {{ $t('depends on')}}
            </b-button>

            <b-collapse id="collapse-1" class="mt-12 mb-12"> -->


            <b-row>


              <b-col cols="4">


                <div class="demo-inline-spacing">




                  <b-form-checkbox v-model="request.dependsOn" value="distance" @change="checker($event)">
                    {{ $t('depends on distance') }}
                  </b-form-checkbox>


                  <small v-if="errors && ('dependsOn' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn'][0]) }}
                  </small>

                </div>

              </b-col>


              <b-col cols="4">
                <b-form-group :label="$t('operator')" label-for="vi-devices-id">
                  <v-select v-model="request.dependsOn_distance_operator"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => $t(d.name)"
                    :options="[...searchoperations]" :reduce="d => d.id" />
                  <small v-if="errors && ('dependsOn_distance_operator' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn_distance_operator'][0]) }}

                  </small>
                </b-form-group>
              </b-col>


              <b-col cols="4">
                <b-form-group :label="$t('distance Km')" label-for="distance">
                  <cleave id="dependsOn_duration" v-model="request.distance" class="form-control" :raw="false" :options="{
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                  }" placeholder="10,000" />
                </b-form-group>
              </b-col>

            </b-row>

            <!-- duration started_work -->

            <b-row>


              <b-col cols="4">


                <div class="demo-inline-spacing">




                  <b-form-checkbox v-model="request.dependsOn" value="duration" @change="checker($event)">
                    {{ $t('depends on duration') }}
                  </b-form-checkbox>


                  <small v-if="errors && ('dependsOn' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn'][0]) }}
                  </small>

                </div>

              </b-col>
              <b-col cols="4">
                <b-form-group :label="$t('operator')" label-for="vi-devices-id">
                  <v-select v-model="request.dependsOn_duration_operator"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => $t(d.name)"
                    :options="[...searchoperations]" :reduce="d => d.id" />
                  <small v-if="errors && ('dependsOn_duration_operator' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn_duration_operator'][0]) }}
                  </small>
                </b-form-group>
              </b-col>


              <b-col cols="4">
                <b-form-group :label="$t('duration Hr')" label-for="dependsOn_duration">
                  <cleave id="dependsOn_duration" v-model="request.dependsOn_duration" class="form-control" :raw="false"
                    :options="{
                      numeral: true,
                      numeralThousandsGroupStyle: 'thousand',
                    }" placeholder="00:00" />
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col cols="4">
                <div class="demo-inline-spacing">
                  <b-form-checkbox v-model="request.dependsOn" value="campLeave">
                    {{ $t('depends on camp Leave') }}
                  </b-form-checkbox>
                </div>
              </b-col>

              <b-col cols="8">
                <b-form-group :label="$t('show depend on status')" label-for="vi-devices-id">
                  <v-select v-model="request.status"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => $t(d.name)"
                    :options="[...statusOptions]" :reduce="d => d.id" />
                  <small v-if="errors && ('dependsOn_duration_operator' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn_duration_operator'][0]) }}
                  </small>
                </b-form-group>
              </b-col>

             
            </b-row>
            <!-- duration   end  -->


            <!-- </b-collapse> -->
          </b-col>

        </b-row>


        <template #code>
          {{ codeCollapseBoostrapVue }}
        </template>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type == 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type == 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('supportDevices')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>



    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors"
        :loading="dataTableloading || loading" :getReport="getReport" :total="total" :from="from" :to="to"
        :sortData="sortData" />

    </div>



  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BFormRadio,
  BCollapse, VBToggle,
} from 'bootstrap-vue'

import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import reportForm from '@/app/reports/absence/reportForm'
//import reportForm from '@/app/reports/share/reportForm'
import GeofenceReportLogic from '@/app/reports/absence/logic'
import { codeCollapseBoostrapVue } from './code'

import { ExportDataServices } from '@/share/reports/exportService'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import { ReportSetting } from '@/views/reports/ReportSettings'

import ReportOptions from '@/views/reports/components/options.js'
import DataTable from '@/views/reports/data-table/DataTable.vue'

export default {
  name: 'AbsenceReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    BFormRadio,
    Cleave,
    BCollapse, VBToggle,
    ToggleCollapse,
    DevicesListFilters,
    DataTable
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,

  },
  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },

  setup(props, { root }) {



  const statusOptions=[{id:'all',name:'all'},{id:'absent',name:'absent'},{id:'notAbsent',name:'notAbsent'}]

    const { devices } = FilterLogic()


    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {

      delete data['type']
      if (data['isSupport'] == "all") {
        delete data['isSupport']
        delete request.value.isSupport
      }

      Object.assign(request.value, data);
    }



    const rangeDate = ref('')
    const checker = (event) => {

      // alert(event);

    }
    const tableRef = ref(null)
    const { contracts, type, owners, searchoperations, reFilterDevices } = reportForm()

    const { report_data, request, errors, loading, getReport, total, from, to, isSortDirDesc, sortBy, dataTableloading } = GeofenceReportLogic()
    const sortData = (data) => {
      sortBy.value = data.sortBy
      isSortDirDesc.value = data.isSortDirDesc
    }

    const perPageOptions = [5, 10, 25, 50, 100]
    const { pickerOptions } = ReportOptions(request.value)

    const report_wrapper = ref(null)
    const filter_included_fields = ['day', 'device_name', 'status', 'camp_leave', 'started_work', 'duration_string', 'start_trip_time', 'total_distance', 'owner', 'contract']
    const report_fields = [
      {
        key: 'index',
        label: 'id',

      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },

      {
        key: 'day',
        label: 'day',
        sortable: false
      },
      {
        key: 'device_name',
        label: 'device',
        sortable: true
      },
      {
        key: 'status',
        label: 'status',
        sortable: false
      },
      {
        key: 'camp_leave',
        label: 'camp leave',
        sortable: false
      },
      {
        key: 'started_work',
        label: 'started work',
        sortable: false
      },
      {
        key: 'finished_work',
        label: 'finished work at',
        sortable: false
      },
      {
        key: 'duration_string',
        label: 'duration time',
        sortable: false
      },

      {
        key: 'total_distance',
        label: 'total distance',
        sortable: false
      },



    ]




    /// here use root form ass dialy report setting
    const toaster = (msg, variant = 'success', title = 'Success') => {
      root.$root.$bvToast.toast(
        root.$i18n.t(msg), {
        title: root.$i18n.t(title),
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      loading.value = true;
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster('settigs saved succeffly!!', 'success!!')
        loading.value = false;
      }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    onMounted(() => {
      ReportSetting.getSetting('absence').then((res) => {

        request.value = res;
      })

    })
    //here end of   dialy report setting

    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      perPageOptions,

      devices,
      owners,
      contracts,
      searchoperations,

      type,

      pickerOptions,
      report_wrapper,

      request,
      loading,
      errors,
      checker,
      reFilterDevices,
      divicesFilterd,
      merageFilterWithRequest,
      //dialy report settings
      saveDialySetting,
      sortData,
      dataTableloading,
      statusOptions,

    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
